var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "rootEl",
    staticClass: "progress",
    class: [{
      'hidden': !_setup.visible && _vm.slideInOut,
      'slide-in-out': _vm.slideInOut,
      'indeterminate': !_setup.isDeterminate
    }, `${_vm.position}`],
    style: `max-height: ${_vm.size === 'large' ? .5 : _vm.size === 'small' ? .15 : .25}rem;`
  }, [_c('div', {
    class: `progress-bar bg-${_vm.color}`,
    style: _setup.isDeterminate ? `width: ${_vm.percentage}%` : undefined
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };